/* eslint-disable */
import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import TermsContractor from '../../../../../presentation/pages/contractors/amplify/termsContractors'

import { makeContractorsTerms } from '../../../../usecases/contractorsRegister/remote-contracorsRegister-factory'

import { RoutesEnum } from '../../../../../presentation/enums'

const MakeTermsContractors = (): JSX.Element => {
  document.title = 'BuscarMédicos - Termos'
  // const { updateMe, formatPermissions } = useMe()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const dataForm = [
    {
      items: [
        {
          component: 'InputRadio',
          name: 'radioOptions',
          required: true,
          options: [{ label: 'Li os termos e aceito', value: 'opcao1' }],
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Concluir cadastro',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [count, setCount] = useState(10)

  const onSubmit = async (values: any): Promise<void> => {
    try {
      const storedEmail = localStorage.getItem('userEmail')

      if (values.radioOptions) {
        await makeContractorsTerms().post({ email: storedEmail })
        setIsModalVisible(!isModalVisible)
      } else {
        setErrorMessage(
          'É necessário aceitar os termos de uso para concluir o cadastro.',
        )
      }
    } catch (error) {
      console.error('Erro ao aceitar os termos de uso:', error)
      setErrorMessage(
        'Ocorreu um erro ao processar a sua solicitação. Por favor, tente novamente mais tarde.',
      )
    }
  }

  useEffect(() => {
    if (isModalVisible) {
      const countdownInterval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount === 1) {
            clearInterval(countdownInterval)
            history.push(RoutesEnum.SIGNIN)
            return 0
          }
          return prevCount - 1
        })
      }, 1000)
      return () => clearInterval(countdownInterval)
    }
  }, [isModalVisible, history])

  const toggleModalVisibility = () => {
    setIsModalVisible(!isModalVisible)
  }

  return (
    <TermsContractor
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      count={count}
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeTermsContractors
